<!-- Dreamers Blessing Fall 2026 notice, from dreamers-blessing-fall-2026-apply_1.html.
     Shown once per browser, until the deadline, on devices in a teacher time zone
     (see domain/noticePopup.js). -->
<template>
  <div v-if="open && $route.name !== 'DreamersBlessing'" class="scrim" @click.self="close">
    <div class="pop" role="dialog" aria-modal="true" aria-labelledby="notice-title" @keydown.esc="close">
      <div class="pop-top">
        <button ref="closeX" class="x" type="button" :aria-label="t.close" @click="close">&times;</button>
        <span class="kicker">THE DREAM INTERNATIONAL</span>
        <div class="pop-head">
          <h2 id="notice-title"><span>DREAMERS</span><span>BLESSING</span><span class="yr">FALL 2026</span></h2>
          <span class="pop-mark" aria-hidden="true"><svg viewBox="96 123 492 460" xmlns="http://www.w3.org/2000/svg"><path fill="#F1CF63" d="M 107.8 282.2 L 103.7 356.6 L 251.6 354 L 126.9 467.6 L 183.5 521.5 L 346.2 362.6 L 410.2 360.6 L 412.2 291.1 Z M 107.8 282.2"/><path fill="#FFFFFF" d="M 412.9 272.6 L 428.1 130.1 L 428.2 129.4 L 353 129 L 345.9 270 Z M 412.9 272.6"/><path fill="#FFFFFF" d="M 325.5 269.5 L 228.9 149.2 L 175.3 198.7 L 247 267.5 Z M 325.5 269.5"/><path fill="#FFFFFF" d="M 432.9 275.7 L 431.2 352.6 L 550.9 265.7 L 505.5 210.1 Z M 432.9 275.7"/><path fill="#F1CF63" d="M 573.9 355.5 L 269.3 365.1 L 276 574.5 L 348.3 567.5 L 337.3 456.6 L 457.2 552.2 L 501.5 504 L 398.1 422.9 L 580.2 425.9 Z M 573.9 355.5"/></svg></span>
        </div>
        <p class="msg1">{{ t.msg[0] }}<br><span class="nw">{{ t.msg[1] }}</span> <span class="nw">{{ t.msg[2] }}</span></p>
        <p class="cities">{{ t.cities }}</p>
        <span class="deadline">{{ t.deadline }}</span>
      </div>
      <div class="pop-actions">
        <div class="langsw" role="group" aria-label="Language">
          <button type="button" :aria-pressed="String(lang === 'ko')" @click="setLang('ko')">한국어</button>
          <button type="button" :aria-pressed="String(lang === 'en')" @click="setLang('en')">English</button>
        </div>
        <button class="btn btn-ghost" type="button" @click="close">{{ t.close }}</button>
        <button class="btn btn-gold" type="button" @click="apply">{{ t.apply }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { auth } from '@/firebase.config';
import { openLogin } from '@/composables/useLogin';
import {
  deviceTimeZone, isNoticeSeen, loadNoticeLang, markNoticeSeen, saveNoticeLang, shouldShowNotice,
} from '@/domain/noticePopup';

const TEXT = {
  ko: {
    msg: ['화면 너머의 드리머들이,', '이제 직접 만날 날을', '기다리고 있습니다.'],
    cities: '추수감사절 주말 · 산티아고 · 이스탄불 · 암만 · 마카파',
    deadline: '신청 마감 11월 8일 (주일)',
    close: '닫기',
    apply: '신청하기',
  },
  en: {
    msg: ['Our Dreamers beyond the screen', 'are waiting to meet', 'you in person.'],
    cities: 'Thanksgiving weekend · Santiago · Istanbul · Amman · Macapá',
    deadline: 'Apply by Sunday, November 8',
    close: 'Close',
    apply: 'Apply',
  },
};

export default {
  name: 'SiteNoticePopup',
  data: () => ({
    open: shouldShowNotice({ timeZone: deviceTimeZone(), seen: isNoticeSeen() }),
    lang: loadNoticeLang(),
  }),
  computed: {
    t() {
      return TEXT[this.lang];
    },
  },
  mounted() {
    if (this.open) this.$nextTick(() => this.$refs.closeX?.focus());
  },
  methods: {
    setLang(lang) {
      this.lang = lang;
      saveNoticeLang(lang);
    },
    close() {
      this.open = false;
      markNoticeSeen();
    },
    // Applying needs an account so the form can be filled in from My Page.
    apply() {
      this.open = false;
      markNoticeSeen();
      const target = { name: 'DreamersBlessing' };
      if (auth.currentUser) this.$router.push(target);
      else openLogin({ redirect: target });
    },
  },
};
</script>

<style scoped>
.scrim{position:fixed;inset:0;background:rgba(22,26,63,.58);display:flex;align-items:center;justify-content:center;padding:max(16px,env(safe-area-inset-top,0px)) max(16px,env(safe-area-inset-right,0px)) max(16px,env(safe-area-inset-bottom,0px)) max(16px,env(safe-area-inset-left,0px));z-index:100}
.pop{background:var(--band);color:var(--on-band);border-radius:22px;max-width:480px;width:100%;overflow:hidden;box-shadow:0 24px 60px rgba(10,12,40,.35);position:relative;font-family:"Noto Sans KR",var(--display);word-break:keep-all}
.pop-top{padding:44px 30px 26px;display:flex;flex-direction:column;gap:14px;position:relative}
.pop-head{display:grid;grid-template-columns:minmax(0,1fr) auto;gap:18px;align-items:end}
.pop-mark{width:clamp(84px,24vw,116px);pointer-events:none}
.pop-mark svg{display:block;width:100%;height:auto}
.pop h2{font-family:var(--display);font-size:clamp(26px,7.4vw,38px);line-height:1.02;margin:0;letter-spacing:.01em;color:var(--on-band);font-weight:700}
.pop h2 span{display:block}
.pop h2 .yr{color:var(--gold);margin-top:4px}
.pop p{margin:0;color:var(--band-muted)}
.pop .msg1{font-size:16.5px;line-height:1.6;color:var(--on-band)}
.nw{white-space:nowrap}
.kicker{font-family:var(--display);letter-spacing:.16em;font-size:12.5px;margin-bottom:-6px;color:var(--gold);font-weight:600}
.pop .cities{color:var(--on-band);font-family:var(--display);font-size:15px}
.deadline{display:inline-block;background:var(--gold);color:var(--navy-deep);border-radius:999px;padding:4px 12px;font-size:13.5px;font-weight:700;align-self:flex-start;font-family:var(--display)}
.pop-actions{background:var(--navy-deep);padding:16px 30px;display:flex;gap:10px;justify-content:flex-end;align-items:center;flex-wrap:wrap}
.pop-actions .btn-ghost{color:var(--on-band);border-color:rgba(255,255,255,.28)}
.x{position:absolute;right:14px;top:12px;background:rgba(255,255,255,.1);border:0;color:#fff;font-size:20px;line-height:1;cursor:pointer;z-index:1;width:34px;height:34px;border-radius:50%}
.langsw{display:inline-flex;border:1px solid rgba(255,255,255,.2);border-radius:999px;padding:3px;gap:2px;background:rgba(255,255,255,.08);flex:none;margin-right:auto}
.langsw button{border:0;background:none;font-family:var(--display);font-weight:600;font-size:14px;padding:6px 12px;border-radius:999px;color:var(--band-muted);cursor:pointer}
.langsw button[aria-pressed="true"]{background:var(--gold);color:var(--navy-deep)}
</style>
